export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12098.4f364fa2.jpg";